import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { RadioTwoBox } from 'components/universal/radio-two-box';
import { PATHS, ROUTES } from 'constants/routes';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import cls from './registerChoose.module.scss';

export const RegisterChoosePageView = () => {
    const { t } = useTranslation();
    const firstLabel = 'first';
    const [selectedOption, setSelectedOption] = useState<string>(firstLabel);

    return (
        <div className={cls.container}>
            <div className={cls.columnLeft}>
                <Heading
                    className={cls.heading}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('registerChoose.title')}
                </Heading>
                <Paragraph
                    className={cls.description}
                    >
                    {t('registerChoose.description')}
                </Paragraph>
                <RadioTwoBox 
                    labelFirst={t('registerChoose.radioFirstDescription')}
                    labelSecond={t('registerChoose.radioSecondDescription')}
                    name="customRadio"
                    valueFirst="first"
                    valueSecond="second"
                    value={selectedOption}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSelectedOption(e.target.value)}
                />
                <div
                    className={cls.buttonWrapper}
                    >
                    <Link to={selectedOption === firstLabel ? PATHS.REGISTRATION_EMPLOYEE : PATHS.REGISTRATION}>
                        <Button 
                            className={`${cls.button} mx-auto mb-5`}
                        >
                            {t('resetPage.continue')}
                        </Button>
                    </Link>
                </div>
                <Paragraph className="text-center">
                    {t('registration.alreadyAccount')}{' '}
                    <Link to={ROUTES.LOGIN.path}>
                        <b>{t(`registration.${ROUTES.LOGIN.name}`)}</b>
                    </Link>
                </Paragraph>
            </div>
        </div>
    );
};
